import { render } from "./Testimonial5Page.vue?vue&type=template&id=d53276b4&scoped=true&ts=true"
import script from "./Testimonial5Page.vue?vue&type=script&lang=ts"
export * from "./Testimonial5Page.vue?vue&type=script&lang=ts"

import "./Testimonial5Page.vue?vue&type=style&index=0&id=d53276b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d53276b4"]])

export default __exports__